import { indexBy, invertObj, map, pipe, prop } from 'ramda';

import { SearchSortByItemConfig } from '../../types/SearchSortByItemConfig.ts';

const indexByValue = indexBy<{ value: string }>(prop('value'));
const mapSlug = map<{ slug: string }, string>(({ slug }) => slug);

const getSortByValueToSlug = pipe<
  [SearchSortByItemConfig[]],
  Record<string, SearchSortByItemConfig>,
  Record<string, string>
>(indexByValue as any, mapSlug);

export interface SearchSortByMaps {
  defaultValue: string;
  valueToSlug: Record<string, string>;
  slugToValue: Record<string, string>;
}

export const getSortByMaps = (sortByItems: SearchSortByItemConfig[]): SearchSortByMaps => {
  const valueToSlug = getSortByValueToSlug(sortByItems);
  return {
    defaultValue: sortByItems.find(({ isDefault }) => isDefault)?.value ?? sortByItems[0].value,
    valueToSlug,
    slugToValue: invertObj(valueToSlug),
  };
};
